import React from 'react'

const ModelContext = React.createContext(null)

export const Provider = ModelContext.Provider
export const Consumer = ModelContext.Consumer

export default ModelContext
